import * as React from 'react';
import { ordered, recipes } from './Dataset';
import Material from './Material';
import Link from './Link';
import { Action, createBrowserHistory, History, Location, UnregisterCallback } from 'history';

export interface IAppState {
  selected: string;
  stop?: UnregisterCallback;
  history: History;
}

class App extends React.Component<{}, IAppState> {
  constructor(props: any, context: any) {
    super(props, context);
    this.state = {
      selected: '',
      history: createBrowserHistory({
        forceRefresh: false,      // Set true to force full page refreshes
        keyLength: 127,             // The length of location.key
      }),
    };
  }

  private hashToName(location: any) {
    const { hash } = location;
    const selected = hash && hash.length ? hash.substr(1) : '';
    return selected;
  }

  private onNavigate(location: Location, action: Action) {
    const selected = this.hashToName(location);
    // window.scrollTo(0, 0);
    this.setState({ selected });
  }

  public componentDidMount() {
    const stop = this.state.history.listen((l: any, a: any) => this.onNavigate(l, a));
    const selected = this.hashToName(window.location);
    this.setState({ stop, selected });
  }

  public componentWillUnmount() {
    if (this.state.stop) {
      this.state.stop();
    }
  }

  private readonly onChange = (e: React.ChangeEvent<any>) => {
    const selected = e.target.value;
    window.location.assign(`#${selected}`);
  }

  public render() {
    return (
      <div className="root">
        <select id="resource" onChange={this.onChange} value={this.state.selected}>
          <option value="">[All]</option>
          {ordered.map((item) => (<option key={item.id} value={item.id}>{item.name}</option>))}
        </select>
        {!!recipes[this.state.selected] && <Material item={recipes[this.state.selected]} />}
        {!recipes[this.state.selected] && this.renderIndex()}
      </div>
    );
  }

  public renderIndex() {
    return (
      <React.Fragment>
        <h2>All Resources:</h2>
        <ul className="uses">
          {ordered.map(item => (
            <li key={item.id}><Link icon={item.id} label={item.name} location={`#${item.id}`} /></li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx